// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../imageSize.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../index.generated';
export const CustomProductCarouselCardFragmentDoc = `
    fragment customProductCarouselCard on CarouselCustomProduct {
  image {
    ...cmsImageSizes
  }
  description
  link {
    ...link
  }
  title
}
    `;